export default __webpack_public_path__ + "static/media/d29.67af5258.jpeg";